import { render } from "./AppAvatar.vue?vue&type=template&id=01c032aa&scoped=true"
import script from "./AppAvatar.vue?vue&type=script&lang=js"
export * from "./AppAvatar.vue?vue&type=script&lang=js"

import "./AppAvatar.vue?vue&type=style&index=0&id=01c032aa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c032aa"]])

export default __exports__